import * as React from 'react';
import { ModalWindow, useDeviceType } from '@cian/ui-kit';

import { ErrorBlock } from '../ErrorBlock';

export interface IErrorModalProps {
  onClose: () => void;
  open?: boolean;
}
export const ErrorModal = (props: IErrorModalProps) => {
  const isHandheld = useDeviceType() !== 'desktop';
  const { onClose, open } = props;

  return (
    <ModalWindow
      open={!!open}
      width={448}
      height={isHandheld ? '100%' : undefined}
      onClose={onClose}
      content={
        <ErrorBlock
          title="Произошла ошибка"
          text="Попробуйте ещё раз"
          buttonText="Хорошо"
          isFullSize={isHandheld}
          onClick={onClose}
        />
      }
    />
  );
};

ErrorModal.displayName = 'ErrorModal';
